import { Button, Drawer } from "antd";
import AddPartTypeForm from "../forms/add-part-type-form";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import partTypesStorage from "../storages/part-types";

/* eslint-disable-next-line */
export interface AddPartTypeDialogProps {
  opened: boolean;
  parentKey: string | null;
  onToggle: () => void;
  onSelect: (partTypeId: string[]) => void;
}

export function AddPartTypeDialog(props: AddPartTypeDialogProps) {
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [image, setImage] = useState<string>("");

  const {
    opened,
    onToggle,
    onSelect,
  } = props;

  const onSubmitted = () => {
    let key = name
      .toLowerCase()
      .split(/\s/g)
      .map((word) => word[0].toUpperCase() + word.slice(1))
      .join("");
    if (props.parentKey) {
      key = `${props.parentKey}:${key}`;
    }
    partTypesStorage.addPartType({
      parentKey: props.parentKey ? props.parentKey : undefined,
      key,
      name,
      description,
      imageUrl: image,
    })
      .then((partType) => {
        if (partType) {
          setName("");
          setDescription("");
          setImage("");
          onSelect([partType.key]);
        }
      });
  }
  return (
    <Drawer
      title="Add part type"
      width={520}
      closable={true}
      onClose={onToggle}
      open={opened}
    >
      <AddPartTypeForm
        name={name}
        description={description}
        image={image}
        setName={setName}
        setDescription={setDescription}
        setImage={setImage}
      />
      <Button
        type="primary"
        onClick={onSubmitted}
        disabled={!name || !description}
      >
        Save part type
      </Button>
    </Drawer>
  );
}

export default observer(AddPartTypeDialog);
